// 영수증 번역 상수
import type { Language, Locale } from '@/config/locales';
import type { ReceiptTranslations } from './types';

// #522 — Locale 단일 출처 정합 (15언어 전수).
export const receiptTranslations:
  & Record<Language, ReceiptTranslations>
  & Record<Exclude<Locale, Language>, ReceiptTranslations> = {
  ko: {
    title: '영수증',
    orderNumber: '주문번호',
    date: '날짜',
    time: '시간',
    menu: '메뉴',
    qty: '수량',
    price: '가격',
    subtotal: '소계',
    tax: '세금 (16%)',
    tip: '팁',
    pointsUsed: '포인트 사용',
    total: '총액',
    paymentMethod: '결제 방법',
    cardPayment: '카드 결제',
    cashPayment: '현금 결제',
    transferPayment: '계좌이체',
    receipt: '영수증',
    taxInvoice: '세금계산서',
    close: '닫기',
    restaurantName: 'OLULO 테이블 오더 레스토랑',
    table: '테이블 1',
    thankYou: '감사합니다!',
    tableOrderService: '테이블 주문 서비스',
    loadingOrder: '주문 정보를 불러오는 중...',
    orderNotFound: '주문을 찾을 수 없습니다.',
    loginRequired: '로그인이 필요합니다.',
    loadFailed: '주문 정보를 불러오지 못했습니다.',
  },
  es: {
    title: 'Recibo',
    orderNumber: 'Número de pedido',
    date: 'Fecha',
    time: 'Hora',
    menu: 'Menú',
    qty: 'Cant.',
    price: 'Precio',
    subtotal: 'Subtotal',
    tax: 'Impuesto (16%)',
    tip: 'Propina',
    pointsUsed: 'Puntos usados',
    total: 'Total',
    paymentMethod: 'Método de pago',
    cardPayment: 'Tarjeta',
    cashPayment: 'Efectivo',
    transferPayment: 'Transferencia',
    receipt: 'Recibo',
    taxInvoice: 'Factura',
    close: 'Cerrar',
    restaurantName: 'OLULO Table Order Restaurant',
    table: 'Mesa 1',
    thankYou: 'Gracias por su compra!',
    tableOrderService: 'Servicio de pedidos de mesa',
    loadingOrder: 'Cargando informacion del pedido...',
    orderNotFound: 'No se encontro el pedido.',
    loginRequired: 'Inicio de sesion requerido.',
    loadFailed: 'No se pudo cargar la informacion del pedido.',
  },
  en: {
    title: 'Receipt',
    orderNumber: 'Order number',
    date: 'Date',
    time: 'Time',
    menu: 'Menu',
    qty: 'Qty',
    price: 'Price',
    subtotal: 'Subtotal',
    tax: 'Tax (16%)',
    tip: 'Tip',
    pointsUsed: 'Points used',
    total: 'Total',
    paymentMethod: 'Payment method',
    cardPayment: 'Card',
    cashPayment: 'Cash',
    transferPayment: 'Bank transfer',
    receipt: 'Receipt',
    taxInvoice: 'Tax Invoice',
    close: 'Close',
    restaurantName: 'OLULO Table Order Restaurant',
    table: 'Table 1',
    thankYou: 'Thank you for your order!',
    tableOrderService: 'Table Ordering Service',
    loadingOrder: 'Loading order information...',
    orderNotFound: 'Order not found.',
    loginRequired: 'Login required.',
    loadFailed: 'Failed to load order information.',
  },
  pt: {
    title: 'Recibo',
    orderNumber: 'Número do pedido',
    date: 'Data',
    time: 'Hora',
    menu: 'Menu',
    qty: 'Qtd.',
    price: 'Preço',
    subtotal: 'Subtotal',
    tax: 'Imposto (16%)',
    tip: 'Gorjeta',
    pointsUsed: 'Pontos usados',
    total: 'Total',
    paymentMethod: 'Forma de pagamento',
    cardPayment: 'Cartão',
    cashPayment: 'Dinheiro',
    transferPayment: 'Transferência',
    receipt: 'Recibo',
    taxInvoice: 'Fatura',
    close: 'Fechar',
    restaurantName: 'OLULO Table Order Restaurant',
    table: 'Mesa 1',
    thankYou: 'Obrigado pelo seu pedido!',
    tableOrderService: 'Serviço de pedidos na mesa',
    loadingOrder: 'Carregando informações do pedido...',
    orderNotFound: 'Pedido não encontrado.',
    loginRequired: 'É necessário fazer login.',
    loadFailed: 'Não foi possível carregar as informações do pedido.',
  },
  fr: {
    title: 'Reçu',
    orderNumber: 'Numéro de commande',
    date: 'Date',
    time: 'Heure',
    menu: 'Menu',
    qty: 'Qté',
    price: 'Prix',
    subtotal: 'Sous-total',
    tax: 'Taxe (16%)',
    tip: 'Pourboire',
    pointsUsed: 'Points utilisés',
    total: 'Total',
    paymentMethod: 'Mode de paiement',
    cardPayment: 'Carte',
    cashPayment: 'Espèces',
    transferPayment: 'Virement',
    receipt: 'Reçu',
    taxInvoice: 'Facture',
    close: 'Fermer',
    restaurantName: 'OLULO Table Order Restaurant',
    table: 'Table 1',
    thankYou: 'Merci pour votre commande !',
    tableOrderService: 'Service de commande à table',
    loadingOrder: 'Chargement des informations de la commande...',
    orderNotFound: 'Commande introuvable.',
    loginRequired: 'Connexion requise.',
    loadFailed: 'Impossible de charger les informations de la commande.',
  },
  zh: {
    title: '收据',
    orderNumber: '订单号',
    date: '日期',
    time: '时间',
    menu: '菜单',
    qty: '数量',
    price: '价格',
    subtotal: '小计',
    tax: '税费 (16%)',
    tip: '小费',
    pointsUsed: '已用积分',
    total: '总计',
    paymentMethod: '支付方式',
    cardPayment: '银行卡',
    cashPayment: '现金',
    transferPayment: '转账',
    receipt: '收据',
    taxInvoice: '发票',
    close: '关闭',
    restaurantName: 'OLULO Table Order Restaurant',
    table: '1号桌',
    thankYou: '感谢您的惠顾！',
    tableOrderService: '桌边点餐服务',
    loadingOrder: '正在加载订单信息...',
    orderNotFound: '未找到订单。',
    loginRequired: '需要登录。',
    loadFailed: '订单信息加载失败。',
  },
  ja: {
    title: 'レシート',
    orderNumber: '注文番号',
    date: '日付',
    time: '時間',
    menu: 'メニュー',
    qty: '数量',
    price: '価格',
    subtotal: '小計',
    tax: '税 (16%)',
    tip: 'チップ',
    pointsUsed: 'ポイント利用',
    total: '合計',
    paymentMethod: '支払い方法',
    cardPayment: 'カード',
    cashPayment: '現金',
    transferPayment: '振込',
    receipt: 'レシート',
    taxInvoice: '請求書',
    close: '閉じる',
    restaurantName: 'OLULO Table Order Restaurant',
    table: 'テーブル 1',
    thankYou: 'ご注文ありがとうございます！',
    tableOrderService: 'テーブルオーダーサービス',
    loadingOrder: '注文情報を読み込んでいます...',
    orderNotFound: '注文が見つかりません。',
    loginRequired: 'ログインが必要です。',
    loadFailed: '注文情報を読み込めませんでした。',
  },
  hi: {
    title: 'रसीद',
    orderNumber: 'ऑर्डर नंबर',
    date: 'तारीख',
    time: 'समय',
    menu: 'मेनू',
    qty: 'मात्रा',
    price: 'कीमत',
    subtotal: 'उप-योग',
    tax: 'कर (16%)',
    tip: 'टिप',
    pointsUsed: 'उपयोग किए गए पॉइंट',
    total: 'कुल',
    paymentMethod: 'भुगतान विधि',
    cardPayment: 'कार्ड',
    cashPayment: 'नकद',
    transferPayment: 'बैंक ट्रांसफर',
    receipt: 'रसीद',
    taxInvoice: 'इनवॉइस',
    close: 'बंद करें',
    restaurantName: 'OLULO Table Order Restaurant',
    table: 'टेबल 1',
    thankYou: 'आपके ऑर्डर के लिए धन्यवाद!',
    tableOrderService: 'टेबल ऑर्डर सेवा',
    loadingOrder: 'ऑर्डर की जानकारी लोड हो रही है...',
    orderNotFound: 'ऑर्डर नहीं मिला।',
    loginRequired: 'लॉगिन आवश्यक है।',
    loadFailed: 'ऑर्डर की जानकारी लोड नहीं हो सकी।',
  },
  de: {
    title: 'Beleg',
    orderNumber: 'Bestellnummer',
    date: 'Datum',
    time: 'Uhrzeit',
    menu: 'Menü',
    qty: 'Menge',
    price: 'Preis',
    subtotal: 'Zwischensumme',
    tax: 'Steuer (16%)',
    tip: 'Trinkgeld',
    pointsUsed: 'Eingelöste Punkte',
    total: 'Gesamt',
    paymentMethod: 'Zahlungsmethode',
    cardPayment: 'Karte',
    cashPayment: 'Bargeld',
    transferPayment: 'Überweisung',
    receipt: 'Beleg',
    taxInvoice: 'Rechnung',
    close: 'Schließen',
    restaurantName: 'OLULO Table Order Restaurant',
    table: 'Tisch 1',
    thankYou: 'Vielen Dank für Ihre Bestellung!',
    tableOrderService: 'Tischbestellservice',
    loadingOrder: 'Bestellinformationen werden geladen...',
    orderNotFound: 'Bestellung nicht gefunden.',
    loginRequired: 'Anmeldung erforderlich.',
    loadFailed: 'Bestellinformationen konnten nicht geladen werden.',
  },
  it: {
    title: 'Ricevuta',
    orderNumber: 'Numero ordine',
    date: 'Data',
    time: 'Ora',
    menu: 'Menu',
    qty: 'Qtà',
    price: 'Prezzo',
    subtotal: 'Subtotale',
    tax: 'Imposta (16%)',
    tip: 'Mancia',
    pointsUsed: 'Punti utilizzati',
    total: 'Totale',
    paymentMethod: 'Metodo di pagamento',
    cardPayment: 'Carta',
    cashPayment: 'Contanti',
    transferPayment: 'Bonifico',
    receipt: 'Ricevuta',
    taxInvoice: 'Fattura',
    close: 'Chiudi',
    restaurantName: 'OLULO Table Order Restaurant',
    table: 'Tavolo 1',
    thankYou: 'Grazie per il suo ordine!',
    tableOrderService: 'Servizio di ordinazione al tavolo',
    loadingOrder: "Caricamento delle informazioni dell'ordine...",
    orderNotFound: 'Ordine non trovato.',
    loginRequired: 'Accesso richiesto.',
    loadFailed: "Impossibile caricare le informazioni dell'ordine.",
  },
  ru: {
    title: 'Чек',
    orderNumber: 'Номер заказа',
    date: 'Дата',
    time: 'Время',
    menu: 'Меню',
    qty: 'Кол-во',
    price: 'Цена',
    subtotal: 'Подытог',
    tax: 'Налог (16%)',
    tip: 'Чаевые',
    pointsUsed: 'Использовано баллов',
    total: 'Итого',
    paymentMethod: 'Способ оплаты',
    cardPayment: 'Карта',
    cashPayment: 'Наличные',
    transferPayment: 'Банковский перевод',
    receipt: 'Чек',
    taxInvoice: 'Счёт-фактура',
    close: 'Закрыть',
    restaurantName: 'OLULO Table Order Restaurant',
    table: 'Стол 1',
    thankYou: 'Спасибо за ваш заказ!',
    tableOrderService: 'Сервис заказа за столом',
    loadingOrder: 'Загрузка информации о заказе...',
    orderNotFound: 'Заказ не найден.',
    loginRequired: 'Требуется вход в систему.',
    loadFailed: 'Не удалось загрузить информацию о заказе.',
  },
  ar: {
    title: 'الإيصال',
    orderNumber: 'رقم الطلب',
    date: 'التاريخ',
    time: 'الوقت',
    menu: 'القائمة',
    qty: 'الكمية',
    price: 'السعر',
    subtotal: 'المجموع الفرعي',
    tax: 'الضريبة (16%)',
    tip: 'الإكرامية',
    pointsUsed: 'النقاط المستخدمة',
    total: 'الإجمالي',
    paymentMethod: 'طريقة الدفع',
    cardPayment: 'بطاقة',
    cashPayment: 'نقدًا',
    transferPayment: 'تحويل بنكي',
    receipt: 'الإيصال',
    taxInvoice: 'فاتورة',
    close: 'إغلاق',
    restaurantName: 'OLULO Table Order Restaurant',
    table: 'طاولة 1',
    thankYou: 'شكرًا لطلبكم!',
    tableOrderService: 'خدمة الطلب على الطاولة',
    loadingOrder: 'جارٍ تحميل معلومات الطلب...',
    orderNotFound: 'لم يتم العثور على الطلب.',
    loginRequired: 'تسجيل الدخول مطلوب.',
    loadFailed: 'تعذر تحميل معلومات الطلب.',
  },
  vi: {
    title: 'Biên lai',
    orderNumber: 'Số đơn hàng',
    date: 'Ngày',
    time: 'Giờ',
    menu: 'Thực đơn',
    qty: 'SL',
    price: 'Giá',
    subtotal: 'Tạm tính',
    tax: 'Thuế (16%)',
    tip: 'Tiền tip',
    pointsUsed: 'Điểm đã dùng',
    total: 'Tổng cộng',
    paymentMethod: 'Phương thức thanh toán',
    cardPayment: 'Thẻ',
    cashPayment: 'Tiền mặt',
    transferPayment: 'Chuyển khoản',
    receipt: 'Biên lai',
    taxInvoice: 'Hóa đơn',
    close: 'Đóng',
    restaurantName: 'OLULO Table Order Restaurant',
    table: 'Bàn 1',
    thankYou: 'Cảm ơn quý khách đã đặt hàng!',
    tableOrderService: 'Dịch vụ gọi món tại bàn',
    loadingOrder: 'Đang tải thông tin đơn hàng...',
    orderNotFound: 'Không tìm thấy đơn hàng.',
    loginRequired: 'Cần đăng nhập.',
    loadFailed: 'Không thể tải thông tin đơn hàng.',
  },
  th: {
    title: 'ใบเสร็จ',
    orderNumber: 'หมายเลขคำสั่งซื้อ',
    date: 'วันที่',
    time: 'เวลา',
    menu: 'เมนู',
    qty: 'จำนวน',
    price: 'ราคา',
    subtotal: 'ยอดรวมย่อย',
    tax: 'ภาษี (16%)',
    tip: 'ทิป',
    pointsUsed: 'แต้มที่ใช้',
    total: 'ยอดรวม',
    paymentMethod: 'วิธีการชำระเงิน',
    cardPayment: 'บัตร',
    cashPayment: 'เงินสด',
    transferPayment: 'โอนเงิน',
    receipt: 'ใบเสร็จ',
    taxInvoice: 'ใบกำกับภาษี',
    close: 'ปิด',
    restaurantName: 'OLULO Table Order Restaurant',
    table: 'โต๊ะ 1',
    thankYou: 'ขอบคุณสำหรับคำสั่งซื้อของคุณ!',
    tableOrderService: 'บริการสั่งอาหารที่โต๊ะ',
    loadingOrder: 'กำลังโหลดข้อมูลคำสั่งซื้อ...',
    orderNotFound: 'ไม่พบคำสั่งซื้อ',
    loginRequired: 'ต้องเข้าสู่ระบบ',
    loadFailed: 'ไม่สามารถโหลดข้อมูลคำสั่งซื้อได้',
  },
  nl: {
    title: 'Bon',
    orderNumber: 'Bestelnummer',
    date: 'Datum',
    time: 'Tijd',
    menu: 'Menu',
    qty: 'Aantal',
    price: 'Prijs',
    subtotal: 'Subtotaal',
    tax: 'Belasting (16%)',
    tip: 'Fooi',
    pointsUsed: 'Gebruikte punten',
    total: 'Totaal',
    paymentMethod: 'Betaalmethode',
    cardPayment: 'Kaart',
    cashPayment: 'Contant',
    transferPayment: 'Overschrijving',
    receipt: 'Bon',
    taxInvoice: 'Factuur',
    close: 'Sluiten',
    restaurantName: 'OLULO Table Order Restaurant',
    table: 'Tafel 1',
    thankYou: 'Bedankt voor uw bestelling!',
    tableOrderService: 'Tafelbestelservice',
    loadingOrder: 'Bestelgegevens worden geladen...',
    orderNotFound: 'Bestelling niet gevonden.',
    loginRequired: 'Inloggen vereist.',
    loadFailed: 'Bestelgegevens konden niet worden geladen.',
  },
};

// #632: getAddressInfo(더미 주소/전화 상수) 제거 — 영수증 매장 주소는
// useStoreDetail(GET /api/v1/stores/:id) 실데이터만 사용, 부재 시 줄 숨김.

// 샘플 커스터마이제이션 (언어별)
// #522: Locale(15) 시그니처로 확장 — 샘플(데모) 데이터이므로 ko/es 외 신규 locale 은 en 폴백.
export const getSampleCustomizations = (locale: Locale, itemIndex: number) => {
  if (itemIndex === 0) {
    return locale === 'ko'
      ? [
          '고기 종류: 소고기',
          '매운 정도: 매운맛 (+1,000)',
          '토핑 추가: 치즈 (+2,000)',
          '사이드: 과카몰리 (+3,000)',
        ]
      : locale === 'es'
        ? [
            'Tipo de carne: Res',
            'Nivel de picante: Picante (+MX$1,000)',
            'Topping extra: Queso (+MX$2,000)',
            'Acompanamiento: Guacamole (+MX$3,000)',
          ]
        : [
            'Meat type: Beef',
            'Spice level: Spicy (+$1,000)',
            'Extra topping: Cheese (+$2,000)',
            'Side: Guacamole (+$3,000)',
          ];
  }
  if (itemIndex === 1) {
    return locale === 'ko'
      ? ['크기: 라지 (+2,000)', '추가 딥: 살사 소스']
      : locale === 'es'
        ? ['Tamano: Grande (+MX$2,000)', 'Dip adicional: Salsa']
        : ['Size: Large (+$2,000)', 'Extra dip: Salsa sauce'];
  }
  return undefined;
};
